import { forwardRef, type HTMLAttributes } from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../lib/cn';

export interface BreadcrumbsProps extends HTMLAttributes<HTMLElement> {
  items: { label: string; href?: string }[];
}

export const Breadcrumbs = forwardRef<HTMLElement, BreadcrumbsProps>(
  ({ items, className, ...props }, ref) => {
    return (
      <nav ref={ref} aria-label="breadcrumb" className={cn("flex", className)} {...props}>
        <ol className="flex flex-wrap items-center gap-1.5 break-words text-sm text-muted-foreground sm:gap-2.5">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            const isMobileHidden = index < items.length - 2;

            return (
              <li
                key={index}
                className={cn(
                  "inline-flex items-center gap-1.5",
                  isMobileHidden && !isLast ? "hidden sm:inline-flex" : ""
                )}
              >
                {isMobileHidden && index === items.length - 3 && (
                  <span className="sm:hidden text-muted-foreground">...</span>
                )}
                {isMobileHidden && index === items.length - 3 && (
                  <ChevronRight className="sm:hidden h-3 w-3 text-muted-foreground" />
                )}
                {item.href && !isLast ? (
                  <a
                    href={item.href}
                    className="transition-colors hover:text-foreground"
                  >
                    {item.label}
                  </a>
                ) : (
                  <span className={cn(isLast ? "text-foreground font-medium" : "")}>
                    {item.label}
                  </span>
                )}
                {!isLast && <ChevronRight className="h-3 w-3 text-muted-foreground" />}
              </li>
            );
          })}
        </ol>
      </nav>
    );
  }
);
Breadcrumbs.displayName = "Breadcrumbs";
